export const POST_TYPE = {
    TEXT: "text",
    IMAGE: "image",
    VIDEO: "video",
    CAROUSEL: "carousel",
};

export const ASPECT_RATIO_LABEL = {
    WIDESCREEN: "widescreen",
    SQUARE: "square",
    PORTRAIT: "portrait",
    WIDE_5_4: "wide54",
    PORTRAIT_4_5: "portrait45",
    isValid: value => {
        return value === "widescreen" || value === "square" || value === "portrait" || value === "wide54" || value === "portrait45";
    }
};

export const NOTICE_IMAGE_ASPECT_RATIOS = [
    { width: 16, height: 9, label: "16:9", standardName: ASPECT_RATIO_LABEL.WIDESCREEN },
    { width: 1, height: 1, label: "1:1", standardName: ASPECT_RATIO_LABEL.SQUARE },
    { width: 5, height: 4, label: "5:4", standardName: ASPECT_RATIO_LABEL.WIDE_5_4 },
    { width: 4, height: 5, label: "4:5", standardName: ASPECT_RATIO_LABEL.PORTRAIT_4_5 },
    { width: 9, height: 16, label: "9:16", standardName: ASPECT_RATIO_LABEL.PORTRAIT },
];

export const NOTICE_VIDEO_ASPECT_RATIOS = [
    { width: 16, height: 9, label: "16:9", standardName: ASPECT_RATIO_LABEL.WIDESCREEN },
    { width: 1, height: 1, label: "1:1", standardName: ASPECT_RATIO_LABEL.SQUARE },
];

export const NOTICEBOARD_QUICK_REACTIONS = ["👍", "❤️", "😂", "🎉", "👏", "😮", "😢", "🙏"];

export const NOTICEBOARD_ALL_REACTIONS = [
    "👍", "❤️", "😂", "🎉", "👏", "😮", "😢", "🙏",
    "😊", "😍", "🤩", "🥳", "🙌", "💪", "💡", "🔥",
    "✅", "⭐", "💯", "🤝", "👀", "🤔", "😅", "😞",
    "😡", "🚀", "🌟", "💜", "🫶", "👌", "🤗", "🎯"
];
